/* eslint-disable no-bitwise */
/* eslint-disable no-restricted-syntax */

import XLSX from 'xlsx';
import dayjs from 'dayjs';
import { TIME_FORMAT_UTC_OFFSET_TIMEZONE } from '../dates';

class XLSXFeedEventStrategy {
  constructor(metric) {
    this.farmMap = {};
    this.lineMap = {};
    this.massRatio = metric ? 0.001 : 0.00220462;
    const massUnit = metric ? 'kg' : 'lbs';
    const timeZoneString = dayjs.tz().format(TIME_FORMAT_UTC_OFFSET_TIMEZONE);

    this.sheetRows = [];
    this.sheetRows.push([
      `Farm Name`,
      `Line Name`,
      `Start ${timeZoneString}`,
      `End ${timeZoneString}`,
      'Start Epoch (s)',
      'End Epoch (s)',
      `Mass Monitored (${massUnit})`,
    ]);
  }

  setFarmObjects = (farms) => {
    farms.forEach((f) => {
      this.farmMap[f.id] = f.name;
      f.feed_lines.forEach((l) => {
        this.lineMap[l.id] = l.name;
      });
    });
  };

  processFeedFramePage = (farmId, lineId, dataArray) => {
    const farmName = this.farmMap[farmId];
    const lineName = this.lineMap[lineId];
    dataArray.forEach((d) => {
      this.sheetRows.push([
        farmName,
        lineName,
        new Date(d.s * 1000), // Convert to Date object for proper formatting
        new Date(d.e * 1000), // Convert to Date object for proper formatting
        d.s,
        d.e,
        d.mass * this.massRatio,
      ]);
    });
  };

  // Helper method to create sheet data with proper formatting
  createSheetData = (sheetRows) => {
    const sheetData = {};
    const range = { s: { r: 0, c: 0 }, e: { r: sheetRows.length - 1, c: sheetRows[0].length - 1 } };
    sheetData['!ref'] = XLSX.utils.encode_range(range);

    // Add header row
    sheetRows[0].forEach((cell, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      sheetData[cellAddress] = { v: cell };
    });

    // Add data rows with proper date and number formatting
    const dateFormat = 'yyyy-mm-dd HH:mm';
    const numberFormat = '#,##0.00'; // Format for mass values

    for (let row = 1; row < sheetRows.length; row++) {
      sheetRows[row].forEach((cell, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });

        if ((colIndex === 2 || colIndex === 3) && cell instanceof Date) {
          // Format date columns (Start and End dates)
          sheetData[cellAddress] = {
            v: cell,
            t: 'd',
            z: dateFormat,
          };
        } else if (colIndex === 6 && typeof cell === 'number') {
          // Format numeric mass column
          sheetData[cellAddress] = {
            v: cell,
            t: 'n',
            z: numberFormat,
          };
        } else if (cell === null || cell === undefined) {
          // Empty cells
          sheetData[cellAddress] = { t: 'e', v: 0x2a };
        } else {
          // Regular cells
          sheetData[cellAddress] = { v: cell };
        }
      });
    }

    // Set column widths
    const columnWidths = [
      { wch: 20 }, // Farm Name
      { wch: 20 }, // Line Name
      { wch: 20 }, // Start Date
      { wch: 20 }, // End Date
      { wch: 15 }, // Start Epoch
      { wch: 15 }, // End Epoch
      { wch: 15 }, // Mass
    ];
    sheetData['!cols'] = columnWidths;

    return sheetData;
  };

  createFile = () => {
    const s2ab = (s) => {
      if (typeof ArrayBuffer !== 'undefined') {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      const buf = new Array(s.length);
      for (let i = 0; i !== s.length; i += 1) buf[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };

    const workbook = XLSX.utils.book_new();
    const sheetData = this.createSheetData(this.sheetRows);
    XLSX.utils.book_append_sheet(workbook, sheetData, 'Sheet 1');

    const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
    const wbout = XLSX.write(workbook, wopts);
    return new Blob([s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  };
}
export default XLSXFeedEventStrategy;
